var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"modals":_vm.modals,"header":_vm.header,"methods":_vm.methods},scopedSlots:_vm._u([{key:"cost",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('CostPage',{attrs:{"rows":params,"close":close}}):_vm._e()]}},{key:"income",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('IncomePage',{attrs:{"rows":params,"close":close}}):_vm._e()]}},{key:"shipInvoices",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('InvoiceAttachment',{attrs:{"rows":params,"close":close}}):_vm._e()]}},{key:"batchTime",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
var close = ref.close;
return [(visible)?_c('BatchUpdateTime',{attrs:{"rows":params,"close":close}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }